<template>
  <div class="plan-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/plan/banner.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>百千万人才战略</span>
    </p>
    <div class="section-container intro-box-content">
      <p>科技日新月异，身处互联网时代，我们每天都面临着新的挑战与机遇。</p>
      <p>
        我们深信，无论时代如何变迁，菁英人才都是促进企业发展与进步的圭臬法则。
      </p>
      <p>
        从2018年起，新增百名博士、千名硕士、万名本科生，正式成为新希望的人才发展战略。
      </p>
    </div>

    <div class="section-container mt50">
      <el-row :gutter="20">
        <el-col
          :span="12"
          class="wow animate__slideInUp"
          data-wow-duration="500ms"
        >
          <div class="plan-box">
            <div class="img-box">
              <img
                src="../../../assets/images/plan/1.jpg"
                alt=""
              />
              <p>新希望</p>
              <p>青年企业家合伙人计划</p>
            </div>
            <div class="info-box">
              <p class="title">遴选条件：</p>
              <p>
                •
                毕业于全球综合排名前100或专业排名前50高校，MBA/EMBA/博士/硕士学历；
              </p>
              <p>• 具有3-5年工作经验；</p>
              <p>• 专业背景：战略、金融、投资、财务、经济等专业；</p>
              <p>
                •
                有过海外留学或创业、项目运作经历优先，英文流利、具有国际化视野；
              </p>
              <p>• 创业精神，战略思维，敏锐的市场洞察和分析能力。</p>
            </div>
          </div>
        </el-col>
        <el-col
          :span="12"
          class="wow animate__slideInUp"
          data-wow-duration="500ms"
        >
          <div class="plan-box">
            <div class="img-box">
              <img
                src="../../../assets/images/plan/2.jpg"
                alt=""
              />
              <p>新希望</p>
              <p>全球管理培训生计划</p>
            </div>
            <div class="info-box">
              <p class="title">遴选条件：</p>
              <p>
                • 毕业于全球综合排名前100或专业排名前50高校，硕士或博士学历；
              </p>
              <p>
                •
                专业背景：金融、经济、投资、财会、法务、人力等专业，数学、统计、自然科学等其它理工科，以及农牧、食品、工程等产业相关专业；
              </p>
              <p>
                •
                担任过核心学生干部者、参加全国或国际竞赛获奖者、有创业经历者或其它在校期间有过特殊成就者优先；
              </p>
              <p>• 具有良好的沟通表达能力。</p>
            </div>
          </div></el-col
        >
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "PlanPage",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.plan-container {
  .mt50 {
    margin-top: 50px;
  }

  .plan-box {
    height: 450px;
    overflow: hidden;
  }

  .img-box {
    padding-top: 40px;
    padding-left: 40px;
    padding-right: 40px;
    position: relative;
    box-sizing: border-box;
    height: 145px;
    width: 100%;
    overflow: hidden;
    font-size: 28px;
    color: #fff;
    line-height: 28px;

    > p:nth-child(2) {
      margin-bottom: 18px;
    }

    > img {
      z-index: -1;
      width: 100%;
      height: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .info-box {
    background: #f1f2f3;
    width: 100%;
    height: 305px;
    box-sizing: border-box;
    padding: 40px;
    overflow: hidden;
    line-height: 24px;

    > p {
      text-align: justify;
      margin-bottom: 10px;
      font-size: 13px;
      color: #565c61;
      background: transparent;
    }
  }
}
</style>
